module.exports = {"532525101":"异龙镇","532525102":"宝秀镇","532525103":"坝心镇","532525104":"龙朋镇","532525105":"龙武镇","532525106":"哨冲镇","532525107":"牛街镇","532525201":"新城乡","532525202":"大桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532525.json
// module id = 2630
// module chunks = 0